var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStringIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38406 9.05741H7.82732L4.66787 0.306641H3.20637L0.046875 9.05741H1.44166L2.24821 6.73483H5.58356L6.38406 9.05741ZM3.86739 1.89548H3.97048L5.23791 5.59471H2.59388L3.86739 1.89548Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2889 8.06902C10.5793 8.06902 10.0638 7.72337 10.0638 7.12914C10.0638 6.54694 10.4762 6.23759 11.3858 6.17702L12.9989 6.07394V6.62576C12.9989 7.4444 12.2713 8.06902 11.2889 8.06902ZM10.9552 9.16673C11.8225 9.16673 12.5441 8.7907 12.9383 8.12968H13.0414V9.05753H14.2967V4.54565C14.2967 3.15091 13.3628 2.32617 11.7072 2.32617C10.2094 2.32617 9.14207 3.05389 9.0086 4.18787H10.2701C10.4156 3.72096 10.9189 3.45413 11.6466 3.45413C12.5381 3.45413 12.9989 3.84834 12.9989 4.54565V5.11572L11.2099 5.2188C9.63933 5.31586 8.75391 6.00114 8.75391 7.18971C8.75391 8.39651 9.68175 9.16673 10.9552 9.16673Z",
    fill: "#4F6E90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.298 12.0331H0.046875V10.8867H14.298V12.0331Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringIcon);
export default __webpack_public_path__ + "static/media/string-icon.580a020875c3e4b40f07f6392fc32d28.svg";
export { ForwardRef as ReactComponent };